<template>
  <div class="card">
    <div class="card-header">
      <strong>{{ $t('dashboardCompany.irktIstifadilri') }}</strong>
    </div>
    <div class="card-body">
      <div
        v-for="(u,i) in companyUsers"
        :key="i"
        class="d-flex justify-content-start  mb-3"
      >
        <img
          class="rounded-circle img-thumbnail border mr-2"
          :src="getPhoto(u.user.photo, 'thumbnailCropped')"
          alt=""
          style="width: 50px"
        >
        <div class="about">
          <div class="name">
            {{ u.user.name }} {{ u.user.surname }}
          </div>
          <div class="status">
            <em>{{ u.position }}</em>
            <ProfileTypeBadge
              :profile="u.profileType"
              class="ml-2"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card-footer">
      <router-link
        :to="{name: 'companyProfile'}"
        class="btn btn-sm btn-light-primary"
      >
        {{ $t('dashboardCompany.dahaOxGstr') }}
      </router-link>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {getPhoto, getProfileName} from "@/repositories/Utils";
import {getCompanyUsers} from "@/repositories/GeneralDataRepository";
import ProfileTypeBadge from "@/components/ProfileTypeBadge.vue";

export default {
  name: 'DashboardCompanyUsers',
  components: {ProfileTypeBadge},
  data() {
    return {
      companyUsers: [],
    };
  },

  computed: {
    ...mapState({
      token: state => state.auth.token,
    })
  },
  mounted() {

    getCompanyUsers(this.token).then(data => {
      if (data.code === 200) {
        this.companyUsers = data.users.slice(0, Math.min(data.users.length, 5));
      }
    });
  },
  methods: {

    getProfileName(keyword) {
      return getProfileName(keyword, this.$i18n);
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },


  }
}
</script>
<style scoped>

@keyframes blink {
  50% {
    opacity: 0.2;
  }
}

@-webkit-keyframes blink {
  50% {
    opacity: 0.2;
  }
}

</style>
